var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInterConsulta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 1.9H11.1633C10.7667 0.798 9.72778 0 8.5 0C7.27222 0 6.23333 0.798 5.83667 1.9H1.88889C0.85 1.9 0 2.755 0 3.8V17.1C0 18.145 0.85 19 1.88889 19H15.1111C16.15 19 17 18.145 17 17.1V3.8C17 2.755 16.15 1.9 15.1111 1.9ZM8.5 1.9C9.01944 1.9 9.44444 2.3275 9.44444 2.85C9.44444 3.3725 9.01944 3.8 8.5 3.8C7.98056 3.8 7.55556 3.3725 7.55556 2.85C7.55556 2.3275 7.98056 1.9 8.5 1.9ZM8.5 5.7C10.0678 5.7 11.3333 6.973 11.3333 8.55C11.3333 10.127 10.0678 11.4 8.5 11.4C6.93222 11.4 5.66667 10.127 5.66667 8.55C5.66667 6.973 6.93222 5.7 8.5 5.7ZM14.1667 17.1H2.83333V15.77C2.83333 13.87 6.61111 12.825 8.5 12.825C10.3889 12.825 14.1667 13.87 14.1667 15.77V17.1Z",
    fill: "#656A6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInterConsulta);
export default __webpack_public_path__ + "static/media/iconInterConsulta.733719d26ef134dd2a3968a3d314bd7f.svg";
export { ForwardRef as ReactComponent };